import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "_flex _grow-1 _rounded--common _bgc--light _pa-1" }
const _hoisted_2 = { class: "_flex-basis-30 _shrink-0 _flex _as-fs" }
const _hoisted_3 = { class: "gfu-embed gfu-embed--1x1" }
const _hoisted_4 = { class: "_flex _flex-basis-70" }
const _hoisted_5 = { class: "_pl-2 _whs-normal gfu-flex__container gfu-flex__container--vertical _grow-1" }
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "_flex _grow-1 _jc-sb" }
const _hoisted_8 = {
  class: "gfu-price gfu-price--old gfu-price--tiny _fw-n _ml-1",
  "data-qa": "price-type:Old"
}
const _hoisted_9 = {
  class: "_ml-1",
  "data-qa": "price-type:ThirtyDaysLowest"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_image = _resolveComponent("base-image")
  const _component_display_currency_price = _resolveComponent("display-currency-price")
  const _component_localize = _resolveComponent("localize")
  const _component_add_product_to_cart = _resolveComponent("add-product-to-cart")
  const _component_router_link = _resolveComponent("router-link")

  return (_openBlock(), _createBlock(_component_router_link, {
    class: "_grow-1 _flex gfu-link gfu-link--nofx",
    to: $options.route
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_base_image, {
              class: "gfu-embed__item _rounded--common",
              src: $props.item.mainImageUrl,
              alt: $props.item.productName
            }, null, 8 /* PROPS */, ["src", "alt"])
          ])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h4", {
              title: $props.item.productName,
              class: "gfu-hd gfu-hf--h4 _line-clamp-2",
              "data-qa": "product-name"
            }, _toDisplayString($props.item.productName), 9 /* TEXT, PROPS */, _hoisted_6),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", null, [
                _createVNode(_component_display_currency_price, {
                  "effective-price": $props.item.effectivePrice,
                  price: $props.item.price,
                  "icon-classes": "gfu-icon--tiny",
                  "is-discounted": $props.item.isDiscounted,
                  class: "_flex _ai-c",
                  "data-qa": "product-price"
                }, {
                  "effective-price": _withCtx(({ effectivePrice }) => [
                    _createElementVNode("span", {
                      class: _normalizeClass(["gfu-price gfu-price--text-base", [{'gfu-price--discounted': true}]]),
                      "data-qa": "price-type:Effective"
                    }, _toDisplayString(effectivePrice), 1 /* TEXT */)
                  ]),
                  price: _withCtx(({ price }) => [
                    _createElementVNode("span", _hoisted_8, _toDisplayString(price), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["effective-price", "price", "is-discounted"]),
                ($props.item.isDiscounted)
                  ? (_openBlock(), _createBlock(_component_localize, {
                      key: 0,
                      resource: _ctx.Resources.Product.RewardCardLowestPriceInLast30Days,
                      class: "gfu-bt gfu-bt--caption _tc--lighter",
                      tag: "div"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_display_currency_price, {
                          "format-key": "0",
                          "icon-classes": "gfu-icon--tiny",
                          "effective-price": $props.item.effectivePrice,
                          price: $props.item.price,
                          tag: "span",
                          class: "_flexinline _ai-c"
                        }, {
                          "effective-price": _withCtx(({ effectivePrice }) => [
                            _createElementVNode("span", _hoisted_9, _toDisplayString(effectivePrice), 1 /* TEXT */)
                          ]),
                          _: 1 /* STABLE */
                        }, 8 /* PROPS */, ["effective-price", "price"])
                      ]),
                      _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["resource"]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createVNode(_component_add_product_to_cart, _mergeProps($options.addProductToCartProps, {
                class: "_flex _as-fe _mt-a _ml-1",
                onItemAdded: $options.onProductAdded
              }), null, 16 /* FULL_PROPS */, ["onItemAdded"])
            ])
          ])
        ])
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["to"]))
}